// extracted by mini-css-extract-plugin
export default {"base":"GoogleAuthButton_base__UhChD","icon":"GoogleAuthButton_icon__TJ+DG"};